csui.require.config({
  bundles: {
'otvideo/bundles/otvideo-player': [
'otvideo/controls/video.player/video.player.view',
'otvideo/controls/video.player/clip.filename.view',
'otvideo/controls/node.state/node.state.icons',
'otvideo/lib/otmm/media-annotations.umd'
],
'otvideo/bundles/otvideo-ext': [
'otvideo/utils/commands/open.video',
'otvideo/utils/commands/convert.media',
'otvideo/utils/commands/open.document/otvideo.open.document.delegates',
'otvideo/widgets/nodestable/toolbaritems',
'otvideo/widgets/nodestable/headermenuitems',
'otvideo/widgets/favorites2.table/toolbaritems',
'otvideo/widgets/recentlyaccessedtable/toolbaritems',
'otvideo/widgets/search.results/toolbaritems',
'otvideo/widgets/metadata/header.dropdown.menu.items',
'otvideo/widgets/metadata/versions.toolbaritems'
]
  }
});